<template>
  <div>
    <div class="marker-container">
      <img
        ref="sourceImage"
        src="./../assets/carro.png"
        style="max-width: 250px"
        crossorigin="anonymous"
      />
      <img
        ref="sampleImage"
        src="./../assets/carro.png"
        style="max-width: 250px; position: absolute"
        crossorigin="anonymous"
        @click="showSampleImage"
      />
    </div>
  </div>
</template>

<script>
import * as markerjs2 from "markerjs2";
import { TriangleMarker } from "./Markers/TriangleMarker";
import { StarMarker } from "./Markers/StarMarker";

export default {
  name: "VehicleParstMarker",
  props: {
    state: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      markerArea: null,
      maState: null,
      imgWithMarkers: null,
      markerEventListeners: false,
      firstRender: true,
    };
  },
  watch: {
    state(val) {
      if (val) {
        this.maState = val;
        if (this.firstRender) {
          this.showMarkerArea();
          this.markerArea.startRenderAndClose();
          this.firstRender = false;
        }
      }
    },
  },
  mounted() {
    const { sourceImage, targetRoot } = this.setSourceImage();
    this.markerArea = new markerjs2.MarkerArea(sourceImage);
  },
  beforeDestroy() {
    if (this.markerEventListeners) {
      this.markerArea.removeEventListener("render", this.handleRender);
      this.markerArea.removeEventListener("close", this.handleClose);
      this.markerEventListeners = false;
    }
  },
  methods: {
    showSampleImage() {
      if (this.disabled) return;
      this.showMarkerArea();
    },
    setSourceImage() {
      const sourceImage = this.$refs.sourceImage;
      const targetRoot = sourceImage.parentElement;
      return { sourceImage, targetRoot };
    },
    showAllMarkers() {
      this.markerArea.renderMarkersOnly = true;
      if (this.imgWithMarkers) {
        this.$refs.sampleImage.src = this.imgWithMarkers;
      } else {
        this.$refs.sampleImage.src = this.$refs.sourceImage.src;
      }

      if (this.maState) {
        this.markerArea.restoreState(this.maState);
      }
    },
    showMarkerArea() {
      const { sourceImage, targetRoot } = this.setSourceImage();
      this.$refs.sampleImage.src = sourceImage.src;

      this.markerArea.targetRoot = targetRoot;
      this.markerArea.settings.displayMode = "popup";
      this.markerArea.renderMarkersOnly = false;
      this.markerArea.availableMarkerTypes = [
        markerjs2.FrameMarker,
        markerjs2.EllipseMarker,
        TriangleMarker,
        StarMarker,
      ];

      if (!this.markerEventListeners) {
        this.markerArea.addEventListener("render", (event) =>
          this.handleRender(event)
        );
        this.markerArea.addEventListener("close", (event) =>
          this.handleClose(event)
        );

        this.markerEventListeners = true;
      }

      this.markerArea.show();

      if (this.maState) {
        this.markerArea.restoreState(this.maState);
      }
    },
    handleRender(event) {
      this.imgWithMarkers = event.dataUrl;
      this.maState = event.state;
    },

    handleClose(event) {
      this.showAllMarkers();
      this.$emit("marker-state", this.maState);
    },
  },
};
</script>

<style scoped>
.marker-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

img {
  max-width: 100%;
  cursor: pointer;
}
</style>
